// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2NApF","header":"PatientBlock_header__3kNBB","label":"PatientBlock_label__3XjLU","option":"PatientBlock_option__1IWq6"};